import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const selectScrapItems =
  (scrapCollection, setAccountSetupCompleted = false) =>
    async (dispatch) => {
      dispatch({ type: "UPDATE_SCARP_ITEM_LOADING" });
      try {
        await auction.put("/organization/update/add-classification", {
          classifications: scrapCollection,
        });
        dispatch({ type: "UPDATE_SCARP_ITEM_SUCCESS" });
        notifySuccess("Scrap selected successfully");
        if (setAccountSetupCompleted) {
          setAccountSetupCompleted(true);
        }
      } catch (error) {
        dispatch({ type: "UPDATE_SCARP_ITEM_ERROR" });
        notifyError(
          error.response ? error.response?.data : error.message,
          error.response
        );
      }
    };

export const getScrapFromOrganization = () => async (dispatch) => {
  dispatch({ type: "MY_ORGANIZATION_SCRAP_LOADING" });
  try {
    const { data } = await auction.get("/profile/read/organization");
    dispatch({
      type: "MY_ORGANIZATION_SCRAP_SUCCESS",
      payload: data?.materialClassifications,
    });
  } catch (error) {
    dispatch({ type: "MY_ORGANIZATION_SCRAP_FAILED" });
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response
    );
  }
};

export const getMaterialClassification = () => async (dispatch) => {
  dispatch({ type: "SHOW_SCRAP_ITEM" });
  try {
    const { data } = await auction.get("/material-classification/read");
    dispatch({ type: "GET_SCRAP_ITEMS", payload: data });
  } catch (error) {
    dispatch({ type: "CANNOT_SCRAP_ITEM" });
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response
    );
  }
};

export const deleteMaterialClassification =
  (id, setModalOpen, setScrapItem) => async (dispatch) => {
    dispatch({ type: "DELETE_MATERIAL_CLASSIFICATION_LOADING" });
    try {
      await auction.put(
        `/organization/update/remove-classification/${id}`
      );
      dispatch({ type: "DELETE_MATERIAL_CLASSIFICATION_SUCCESS" });
      notifySuccess("Scrap deleted successfully");
      setModalOpen(false);
      setScrapItem({});
      dispatch(getScrapFromOrganization());
    } catch (error) {
      notifyError(
        error.response ? error.response?.data : error.message,
        error.response?.status
      );
      dispatch({ type: "DELETE_MATERIAL_CLASSIFICATION_FAILED" });
    }
  };
